import api from '@http/api';
import { FormatDate } from '@src/utils/formats';


export interface ILista {
  id: number;
  descricao: string;
  dataCadastro: string;
  programaId: string;
  perfilId: string;
  perfil:{
  pessoa: {
              id: number;
              nome: string;

      },
    },



      programa: {

          nome:string;

      },
}

export interface IGetAllProgramaTv{
  id: number;
  nome: string;
}

interface IResponseReqImpressaoLocal {
  boletoURL: string;
}

interface IResponse {
  error: boolean;
  response?: {
    boletoURL: string;
  };
}


class Services {
  public async GerarCSV(StatusSolicitacao: any, ProgramaId: number) {
    return await api
      .get(`/api/SolicitacaoPrograma/GetAllSolicitacaoProgramaExcel?StatusSolicitacao=${StatusSolicitacao}&ProgramaId=${ProgramaId}`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async GerarPDF(StatusSolicitacao: any, ProgramaId: number){
    return await api
      .get(`/api/SolicitacaoPrograma/GetAllSolicitacaoProgramaPDF?StatusSolicitacao=${StatusSolicitacao}&ProgramaId=${ProgramaId}`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async GetAllProgramaTv()
  {
    return await api
      .get<IGetAllProgramaTv[]>(`/api/Programa/GetAll`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }




}

export default Services;
